var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLecturers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9589 10.6052C13.1125 10.6052 14.0476 9.67007 14.0476 8.51648C14.0476 7.3629 13.1125 6.42773 11.9589 6.42773C10.8053 6.42773 9.87012 7.3629 9.87012 8.51648C9.87012 9.67007 10.8053 10.6052 11.9589 10.6052Z",
    stroke: "#545B5B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1849 16.402C16.1839 15.2815 15.7383 14.2071 14.946 13.4147C14.1536 12.6224 13.0792 12.1768 11.9587 12.1758C10.8378 12.1758 9.76284 12.621 8.97026 13.4136C8.17769 14.2062 7.73242 15.2812 7.73242 16.402H16.1849Z",
    stroke: "#545B5B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1727 10.6052C19.3263 10.6052 20.2615 9.67007 20.2615 8.51648C20.2615 7.3629 19.3263 6.42773 18.1727 6.42773C17.0191 6.42773 16.084 7.3629 16.084 8.51648C16.084 9.67007 17.0191 10.6052 18.1727 10.6052Z",
    stroke: "#545B5B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5765 16.402H22.399C22.399 15.2812 21.9537 14.2062 21.1611 13.4136C20.3685 12.621 19.2936 12.1758 18.1727 12.1758C17.4809 12.1755 16.7996 12.3455 16.189 12.6708",
    stroke: "#545B5B",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82752 10.6052C6.9811 10.6052 7.91627 9.67007 7.91627 8.51648C7.91627 7.3629 6.9811 6.42773 5.82752 6.42773C4.67393 6.42773 3.73877 7.3629 3.73877 8.51648C3.73877 9.67007 4.67393 10.6052 5.82752 10.6052Z",
    stroke: "#545B5B",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42357 16.402H1.60107C1.60107 15.2812 2.04634 14.2062 2.83891 13.4136C3.63149 12.621 4.70645 12.1758 5.82732 12.1758C6.51918 12.1755 7.20047 12.3455 7.81107 12.6708",
    stroke: "#545B5B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecturers);
export default __webpack_public_path__ + "static/media/lecturers.cbb5aab94468cf2eee03d8b835945db7.svg";
export { ForwardRef as ReactComponent };